import { createSelector } from 'reselect';
import { get, pickBy, reduce, forEach, find, map } from 'lodash';

const filter = state => state.events.filter;

export const viewFilterOpenSelector = createSelector(filter, filter => filter.viewFilterOpen);

export const filterSelectedPartnerSelector = createSelector(filter, filter => filter.selectedPartner);
export const filterPartnersSelector = createSelector(filter, filter => filter.partners);
export const selectedPartnerNameSelector = createSelector(
    filterSelectedPartnerSelector,
    filterPartnersSelector,
    (sp, ps) => {
        const partner = find(ps, p => p.id === sp);
        return (partner || {}).name || '';
    }
);

export const sortBySelector = createSelector(filter, f => f.sortBy);
export const orderSelector = createSelector(filter, f => f.order);

export const stagesFilterSelector = createSelector(filter, f => f.stages);
export const artistsFilterSelector = createSelector(filter, f => f.artists);
export const liveFilterSelector = createSelector(filter, f => f.live);
export const nonLinearFilterSelector = createSelector(filter, f => f.nonLinear);
export const filtersOpenSelector = createSelector(filter, f => f.filtersOpen);
export const activityOpenSelector = createSelector(filter, f => f.activityOpen);

export const hasFilterSelector = createSelector(
    stagesFilterSelector,
    artistsFilterSelector,
    liveFilterSelector,
    nonLinearFilterSelector,
    (s, a, l, n) => (s && s.length) || (a && a.length) || (l && l.length) || (n && n.length)
);

export const liveViewSelector = createSelector(filter, f => f.liveView);
export const listViewSelector = createSelector(filter, f => f.listView);

export const partnersForFilter = stages => {
    let partners = {};
    forEach(stages, s => {
        s.scheduleEntries.forEach(se => {
            (get(se, 'linearStates') || []).forEach(ls => {
                partners[ls.partnerId] = ls.partnerName;
            });
            (get(se, 'liveStates') || []).forEach(ls => {
                partners[ls.partnerId] = ls.partnerName;
            });
        });
    });
    partners = map(partners, (v, k) => ({ id: k, name: v }));
    return partners === 0 ? [{ id: null }] : partners;
};

export const hasASelection = (filters, group) => {
    return reduce(
        pickBy(filters, (v, k) => k.startsWith(group)),
        function(result, value) {
            return result || value;
        },
        false
    );
};



// WEBPACK FOOTER //
// ./src/selectors/events/filter.js